import { useEffect, useState } from "react";
import { Button, ComboBox, Header, Input, Label, ListBox, ListBoxItem, Popover, Section, Select, SelectValue } from "react-aria-components";
import IconChevronDown from '../../assets/icons/icon-chevron-down.svg'
import GreyIconChevronDown from '../../assets/icons/icon-chevron-down-grey.svg'

export interface ISelect {
    label?: string,
    labelVisible: boolean
    required?: boolean,
    sections?: ISection[],
    validateRule?: Function,
    validationError?: string,
    onChangeSelect: Function,
    value: any,
    disabled: boolean,
    placeHolder?: string,
    labelClassName?: string
    [other: string | number | symbol]: unknown;
}

export interface ISection {
    name: string
    options: IOption[]
}

export interface IOption {
    text: string,
    value: string,
}


export default function AdobeSectionComboBox({ value, placeHolder, label, labelVisible, required, sections, validateRule, validationError, onChangeSelect, disabled, labelClassName, ...other }: ISelect) {
    const [valid, setValid] = useState();
    function validate(e: React.ChangeEvent<HTMLSelectElement>) {
        if (validateRule) {
            setValid(validateRule(e.target.value))
        }
    }


    return (<div className="input-select__wrapper">
        <ComboBox selectedKey={value ?? null} onSelectionChange={(selected) => onChangeSelect(selected)} isDisabled={disabled} aria-label={label} >
            {labelVisible && <Label className={`small display--block ${labelClassName || ''}`}>{label}{required ? " (required)" : ""}</Label>}
            <Button className="small position--relative width--full">
                <Input placeholder={placeHolder ?? "Please select"} className={`small small--2 input-select__select ${valid !== false ? '' : 'input-select__select--error'} textAlign--left`} />
                <img src={disabled ? GreyIconChevronDown : IconChevronDown} className="input-select__icon" />
            </Button>
            <Popover className={"input-select__pop-over"} >
                {sections &&
                    <ListBox items={sections}>
                        {(section) =>
                            <Section id={section.name}>
                                <Header style={{ fontWeight: 700 }}><h3>{section.name}</h3></Header>
                                {section.options.map((option, i) =>
                                    <ListBoxItem id={option.value} >{`${option.text}`}</ListBoxItem>
                                )}
                            </Section>}
                    </ListBox>
                }
            </Popover>
        </ComboBox>
    </div>)
}